import { Box, Grid, Modal } from "@mui/material";
import React from "react";
import AddRoleTable from "./AddRoleTable";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },

  minHeight: "15vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  paddingRight: "3vh",
  paddingTop: "4vh",
  borderRadius: "5px",
  overflow: "auto",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  addRoleModal: boolean;
  setAddRoleModal: (addRoleModal: boolean) => void;
  rowInfo: any;
}

const AddRoleModal = ({ addRoleModal, setAddRoleModal, rowInfo }: Props) => {
  return (
    <div>
      <Modal
        open={addRoleModal}
        onClose={() => {
          setAddRoleModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{ height: "100%", overflow: "auto" }}
          >
            <AddRoleTable
              id={rowInfo?.node.id!}
              setAddRoleModal={setAddRoleModal}
            />
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default AddRoleModal;
